export const SHOW_LOCATION_BLOCKED = 'find_me.show_location_blocked';
export const HIDE_LOCATION_BLOCKED = 'find_me.hide_location_blocked';

export function showLocationBlocked({id}) {
    return {type: SHOW_LOCATION_BLOCKED, payload: id};
}

export function hideLocationBlocked({id}) {
    return {type: HIDE_LOCATION_BLOCKED, payload: id};
}
